import type { PropsWithChildren } from "react"
import React from "react"
import {
    Box,
    componentStyles,
    PillButton,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket"
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark"

import COPY from "~config/copy-constants"
import { useCopyOrShare } from "~utils/use-copy-or-share"
import Drawer, {
    DrawerPlacement,
    DrawerSize,
} from "~components/shared/todo-lib-react-components/drawer"

interface Props extends PropsWithChildren {
    readonly isOpen?: boolean
    readonly onClose: () => void
}

export default function DrawerWithShareButton({
    isOpen,
    onClose,
    children,
}: Props) {
    const styles = useStyles()
    const copyOrShare = useCopyOrShare()

    return (
        <Drawer
            isOpen={isOpen}
            onClose={onClose}
            size={DrawerSize.Full}
            placement={DrawerPlacement.Bottom}
        >
            <Box style={styles.root}>
                <Box style={styles.top}>
                    <PillButton
                        leftIcon={<FontAwesomeIcon icon={faXmark} />}
                        onClick={onClose}
                    >
                        {COPY.CLOSE}
                    </PillButton>
                    <PillButton
                        leftIcon={
                            <FontAwesomeIcon icon={faArrowUpFromBracket} />
                        }
                        onClick={copyOrShare}
                    >
                        {COPY.SHARE.SHARE}
                    </PillButton>
                </Box>
                {children}
            </Box>
        </Drawer>
    )
}

function useStyles() {
    return componentStyles({
        top: {
            height: "10vh",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
        },
        root: {
            width: "100%",
            height: "90vh",
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
        },
    })
}
